import s from "styled-components";
import { Container } from "reactstrap";
import { HeartsPreloader } from "_c/preloader";
import { Col } from "reactstrap";
import { CircleButton } from "_c/button";

export const Preloader = s(HeartsPreloader)`
  width: 100px;
`;
export const PreloaderContainer = s.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 175px;
`;
export const ContentContainer = s(Container)`
  position: relative;
  z-index: 21;
  && { 
    padding-top: 5px !important;
  }
  @media(max-width: 991px) {
  && { 
    padding-top: 0px !important;
  }

  }
  @media(max-width: 767px) {
    && {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }
`;
export const MasterContainer = s.ul`
  @media(max-width: 991px) {
    padding-top: 5px;
    margin-bottom: 20px;  
  }
`;
export const LeftCol = s(Col)`
`;
export const RightCol = s(Col)`
  @media(max-width: 991px) {
    order: -1;
  }
`;

export const CloseMapBtn = s(CircleButton)`
  position: fixed;
  z-index: 101;
  left: 10px;
  top: 10px;
`;
export const NoResultsText = s.p`
   font-weight: 500;
   margin-left: auto;
   margin-right: auto;
   text-align: center;
   max-width: 450px;
   margin-top: 0;
   color: var(--font-color-emp);
`;
export const NoResultsContainer = s.ul`
  text-align: center;
  margin-top: 15px;
  li {
    margin-bottom: 3px;
  }
  a {
    font-weight: 500;
    color: var(--font-color-emp);
  }
`;
